





































































































































































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import RouteTranslations from "@/locales/routerTranslations";
import "@/plugins/googleMaps";
import SwiperCarousel from "@/components/SwiperCarousel.vue";
import GenericCard from "@/components/stateless/GenericCard.vue";
import {
  CellarsRequests,
  CellarExperiencesRequests,
  CellarProductsRequests, ExperiencesRequests
} from "@/helpers";

@Component({
  components: {
    GenericCard,
    SwiperCarousel
  }
})
export default class CellarDetail extends Vue {
  productsLoading: boolean = false;
  experiencesLoading: boolean = false;
  loading: boolean = false;
  translations: any = RouteTranslations;
  centerMap?: any = null;
  cellarMarkers: Array<any> = [];
  cellar?: any = null;
  productsList?: Array<any> = [];
  experiencesList?: Array<any> = [];
  hideDescrBtn = false;
  elLoaded = false;
  openingHours: string[] = [];
  descriptionShow: boolean = false;

  @Watch("elLoaded")
  handler() {
    // console.log(this.$refs.description);
    if ((this.$refs.description as any).clientHeight > 254)
      this.hideDescrBtn = true;
  }

  descShowManager(show: boolean) {
    show ? (this.descriptionShow = true) : (this.descriptionShow = false);
  }

  mounted() {
    this.getCellar().then(() => {

      console.log(this.cellar);
      // change meta title & meta description

      var description = this.cellar.description.replace(/(<([^>]+)>)/ig, "");
      var url = "https://divinea/cantina/" + this.cellar.id;

      // Use cellar title as fallback if metaTitle is null or empty, with Divinea suffix
      const metaTitle = this.cellar.metaTitle || (this.cellar.title + " | Divinea");
      const metaDescription = this.cellar.metaDescription || description;

      document.title = metaTitle;
      // eslint-disable-next-line
      document.querySelector('meta[name="description"]').setAttribute('content', metaDescription);

      // change Open Graph Meta

      document.querySelector(' meta[property="og:title"]').setAttribute('content', metaTitle);
      document.querySelector(' meta[property="og:description"]').setAttribute('content', metaDescription);
      document.querySelector(' meta[property="og:url"]').setAttribute('content', url);
      document.querySelector(' meta[property="og:image"]').setAttribute('content', this.cellar.cover);

      Promise.all([
        this.getExperienceProducts(),
        this.getCellarExperiences(this.cellar.id)
      ]).then(() => {
        this.centerMap = {
          lat: parseFloat(this.cellar.address ? this.cellar.address.lat : 0),
          lng: parseFloat(this.cellar.address ? this.cellar.address.lng : 0)
        };
        this.cellarMarkers = [
          {
            title: this.cellar.title,
            position: {
              lat: parseFloat(
                this.cellar.address ? this.cellar.address.lat : 0
              ),
              lng: parseFloat(this.cellar.address ? this.cellar.address.lng : 0)
            },
            icon: {
              url: require("@/assets/icons/markerIcon.svg"),
              size: { width: 35, height: 35, f: "px", b: "px" },
              scaledSize: { width: 35, height: 35, f: "px", b: "px" }
            }
          }
        ];
      });
    });
  }

  getCellar() {
    this.loading = true;
    return CellarsRequests.fetch(this.$route.params.id)
      .then((response: any) => {
        // console.log(response);
        this.cellar = response;
        this.openingHours = this.cellar.openingHours
          ? this.cellar.openingHours
            .split("<br>")
            .map((item: string) => item.trim())
          : [];
        this.$emit("headerImage", this.cellar.headerImage);
        this.loading = false;
      })
      .catch((error: Error) => {
        this.loading = false;
        this.$store.dispatch("app/setSnackbarMessage", {
          message: "getCellar: " + error,
          color: "red"
        });
      });
  }
  getCellarExperiences(uid: string) {
    this.experiencesLoading = true;
    let filter = `company_ids=${uid}`;
    ExperiencesRequests.fetchAll(filter)
      .then((response: any) => {
        this.experiencesLoading = false;
        this.experiencesList = response.data;
      })
      .catch((error: Error) => {
        this.experiencesLoading = false;
        this.$store.dispatch("app/setSnackbarMessage", {
          message: "getCellarExperiences: " + error,
          color: "red"
        });
      });
  }
  getExperienceProducts() {
    this.productsLoading = true;
    CellarProductsRequests.with({
      CellarId: this.$route.params.id
    })
      .fetchAll()
      .then((response: any) => {
        this.productsLoading = false;
        this.productsList = response;
      })
      .catch((error: Error) => {
        this.productsLoading = false;
        this.$store.dispatch("app/setSnackbarMessage", {
          message: "getExperienceProducts: " + error,
          color: "red"
        });
      });
  }
  openCellarImageDialog() {
    this.$store
      .dispatch("app/setDialog", {
        type: "cellarImagesDialog",
        state: true,
        childData: this.cellar.images
      })
      .then(() => { })
      .catch(error => {
        console.error(error);
      });
  }
}
